import { formatDistanceToNow, format } from 'date-fns';

export function formatRelative(isoDate: string): string {
  return formatDistanceToNow(new Date(isoDate), { addSuffix: true });
}

export function formatDateTime(isoDate: string): string {
  return format(new Date(isoDate), 'MMM d, yyyy · h:mm a');
}
